import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: BASE });

export function adminApi() {
  return axios.create({ baseURL: BASE, withCredentials: true });
}

export function parseCommandLine(line) {
  const args = [];
  let cur = "";
  let inQ = false;
  for (const ch of line) {
    if (ch === '"') inQ = !inQ;
    else if (ch === " " && !inQ) {
      if (cur) { args.push(cur); cur = ""; }
    } else cur += ch;
  }
  if (cur) args.push(cur);
  // Tolère "SCEWIN_64.exe" en début de ligne (l'app le lance déjà elle-même)
  if (args.length && /^(.*[\\/])?scewin_64(\.exe)?$/i.test(args[0])) args.shift();
  return args;
}

export function parseCommands(text) {
  return text.split("\n").map((l) => l.trim()).filter(Boolean).map(parseCommandLine);
}

export function formatCommands(cmds) {
  return (cmds || [])
    .map((args) => args.map((a) => (a.includes(" ") ? `"${a}"` : a)).join(" "))
    .join("\n");
}

export function fmtDate(v) {
  if (!v) return "—";
  const d = new Date(v);
  return d.toLocaleDateString("fr-FR") + " " + d.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" });
}
